// Shared FAQ items — used by both the homepage FAQ section and the PDP "FAQ" tab.
// Compliance-safe phrasing only. Pre-order language (Ships July 2026) is the
// single source of truth across the site.
export const FAQS = [
  {
    q: "When does PeptiChill ship?",
    a: "PeptiChill is now open for pre-orders. The first batch ships from July 2026. Your card is charged at the time of pre-order to secure your unit, and you'll receive an email with tracking when your PeptiChill is dispatched. Pre-orders ship in the order they were received.",
  },
  {
    q: "Is this suitable for peptide storage?",
    a: "Yes. PeptiChill is designed to provide a compact, temperature-controlled environment ideal for organised storage of research-use peptides. Always follow the storage instructions supplied with your specific peptides.",
  },
  {
    q: "What temperature does it maintain?",
    a: "PeptiChill is designed to hold an internal temperature in the 2–8 °C range, with the live reading shown on the front-mounted digital LCD.",
  },
  {
    q: "Is it suitable for medicines?",
    a: "PeptiChill is sold as general temperature-controlled storage equipment. If you intend to store medicines, please follow the storage instructions provided by your pharmacist, prescriber, manufacturer or supplier.",
  },
  {
    q: "Does it come with a UK plug?",
    a: "Yes. PeptiChill ships with a UK 3-pin plug ready to use straight out of the box.",
  },
  {
    q: "How quickly is it delivered?",
    a: "Pre-orders ship from July 2026. Once dispatched, orders are tracked and typically arrive within 2–3 working days within the UK.",
  },
  {
    q: "What is the warranty?",
    a: "PeptiChill includes a 12-month manufacturer warranty covering manufacturing defects under normal use.",
  },
  {
    q: "Can it be used in a clinic or lab?",
    a: "PeptiChill is designed for home lab, clinic, research and professional storage environments where a compact, clean, temperature-controlled storage solution is required.",
  },
];
